
const ContractForAgreementDetailCtrl = 
        ['$scope', '$filter', '$routeParams', 'DateUtils', '$http', 'UserInfo', 'ContractForAgreement', 'Alert',
            function ($scope, $filter, $routeParams, DateUtils, $http, UserInfo, ContractForAgreement, Alert) {
                /***********************************************************************************************************
                 * Controller Attributes
                 ***********************************************************************************************************/
                var $translate = $filter('translate');

                /***********************************************************************************************************
                 * Scope Attributes
                 ***********************************************************************************************************/

                $scope.action = 'detail';
                $scope.errors = {};

                /***********************************************************************************************************
                 * Scope Watchers
                 ***********************************************************************************************************/


                /***********************************************************************************************************
                 * Controller Methods
                 ***********************************************************************************************************/


                /***********************************************************************************************************
                 * Scope Methods
                 ***********************************************************************************************************/

                $scope.deleteContractForAgreementMode = function ($event) {
                    $event.preventDefault();
                    $scope.action = 'delete';
                };

                $scope.editContractForAgreementMode = function ($event) {
                    $event.preventDefault();
                    $scope.action = 'edit';
                };

                $scope.cancelContractForAgreement = function ($event) {
                    $event.preventDefault();
                    $scope.action = 'detail';
                };

                $scope.canDeleteContractForAgreement = function () {
                    return UserInfo.hasPerm("agreements.delete_contractforagreement");
                };

                $scope.canEditContractForAgreement = function () {
                    return UserInfo.hasPerm("agreements.change_contractforagreement");
                };


                $scope.deleteContractForAgreement = function (id) {
                    ContractForAgreement.deleteContractForAgreement(id).then(function (contract) {
                        $scope.listReload();
                        Alert.createAlert('success', $translate('CONTRACTS.AGREEMENT_DELETED'), true);
                    }).catch(function (error) {

                    });
                };

                $scope.updateContractForAgreement = function (id) {
                    $scope.errors = {};
                    
                    ContractForAgreement.setContractForAgreementDetailPartial(id, $scope.result).then(function (contract) {
                        $scope.listReload();
                        Alert.createAlert('success', $translate('CONTRACTS.AGREEMENT_UPDATED'), true);
                    }).catch(function (error) {
                        $scope.errors = error;
                    });

                };

                $scope.change_agreement_manages = function (value) {
                    if ($scope.action == 'edit') {
                        $scope.result.agreement_manages = value;
                    }
                };

                /***********************************************************************************************************
                 * Controller Initialization
                 ***********************************************************************************************************/


            }]

export {ContractForAgreementDetailCtrl}
